import baseUrl from "../config/baseUrl";

const deleteAll = async ({ token, id,user_id  }) => {
  const formData = new FormData();
  formData.append("document_id", id);
  formData.append("user_id", user_id);

  try {
    const response = await fetch(`${baseUrl}/apireact/bulk_delete_documents`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default deleteAll;
